// Links to Backbone Help Center
export enum HelpCenterLinks {
  EN = 'https://intercom-help.eu/backbone-eu/en/',
  FR = 'https://intercom-help.eu/backbone-eu/fr/',
  DE = 'https://intercom-help.eu/backbone-eu/de/',
}
